import type { NormalizeOAS, OASOutput, OASRequestParams } from 'fets';
import { v4 as uuidv4 } from 'uuid';
import type { ApiClient } from '../fetsClient';
import type openapi from '../openapi';
import type { TagColor } from '../../types/Tags';

type O = NormalizeOAS<typeof openapi>;
type RequestParams = OASRequestParams<O, '/api/tags', 'post'>;
type ResponseBody = OASOutput<O, '/api/tags', 'post'>;
type Params = {
  name: string;
  color: TagColor;
  guid?: string | null | undefined;
};

type Result = Params;

export const createTagFactory = (apiClient: ApiClient) => {
  const createTag = async (variables: Params) => {
    const guid = variables.guid ?? uuidv4();
    const variablesWithGuid = { ...variables, guid };
    const requestBody = mapInputToRequestBody(variablesWithGuid);
    const response = await apiClient['/api/tags'].post(requestBody);
    const responseBody = await response.json();

    return mapResponseToResult(responseBody, variablesWithGuid);
  };

  const mapInputToRequestBody = (input: Result): RequestParams => {
    return {
      json: {
        name: input.name,
        color: input.color,
        guid: input.guid ?? null,
      },
    };
  };

  const mapResponseToResult = (_response: ResponseBody, input: Result): Result => {
    return input;
  };

  return createTag;
};
